import React from "react";
const CloudPhoneFrequentlyAskedQuestions = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-12">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5
              className="card-title text-bold text-center"
              style={{ fontSize: "30px" }}
            >
              سوالات متداول تلفن ابری
            </h5>
            <p className="card-text">
              ثبت نام و تهیه تلفن ثابت ابری چقدر زمان میبرد؟
              <br />
              <ul>
                <li>
                  خرید و فعالسازی خط تلفن ابری یک الی دو روز کاری طول میکشد و
                  فعالسازی سرویس هاستد بصورت آنلاین در لحظه صورت میگیرد.
                </li>
              </ul>
              مالکیت رسمی خطوط به چه شکل هست؟
              <br />
              <ul>
                <li>
                  مالکیت این خطوط بصورت رسمی با خود کاربر میباشد و موقع فعالسازی
                  خط در آسیاتک یک اکانت با کد ملی کاربر ایجاد میشود که در این
                  اکانت در قسمت سرویس ها خط ابری برایش ثبت میشود و مالکیت خط
                  برای کاربر بصورت دائمی میباشد و نیازی به تمدید ندارد.
                </li>
              </ul>
              آیا تلفن اینترنتی فقط با پیش شماره 021 تهران ارائه میشود؟
              <br />
              <ul>
                <li>
                  خیر، در این سرویس میتوانید از پیش شماره هر شهر و استان دیگر به
                  دلخواه خط تلفن مجازی ثبت نام کنید.
                </li>
              </ul>
              برای استفاده از تلفن ثابت ابری نیاز به اینترنت میباشد؟
              <br />
              <ul>
                <li>
                  الزاما خیر، بدون نیاز به هیچ اینترنتی میتوانید از دایورت ساده
                  روی یک خط تلفن بهره ببرید. و اگر سرویس هاستد مکسفون را تهیه
                  کنید بازهم بدون اینترنت میتوانید از تمام امکانات اضافی سانترال
                  مجازی (ivr و داخلی و صفت تماس و تماس خروجی) استفاده کنید.
                </li>
                <li>
                  ولی اگر اینترنت آسیاتک داشته باشید میتوانید از نرم افزارهای
                  سافت فون نظیر زویپر، آسیاتل و… استفاده کرده و از امکانات این
                  اپلیکیش ها استفاده کنید و بابت تماس های دایورتی هم هزینه ای
                  نداشته باشید.
                </li>
              </ul>
              آیا در سرویس تلفن ابری ثابت ملزم به پرداخت هزینه های ماهانه هستیم؟
              <br />
              <ul>
                <li>
                  الزاما خیر، هزینه خرید و فعالسازی خط دائمی است و نیازی به
                  تمدید ندارد. ولی درصورت نیاز به سرویس هاستد، هزینه سرویس هاستد
                  بصورت ماهانه میباشد.
                </li>
              </ul>
              آیا سرویس هاستد برای دقایق مکالمه محدودی قابل استفاده است؟
              <br />
              <ul>
                <li>
                  خیر، کاملا نامحدود است. مثلا وقتی شما بسته 3ماهه هاستد را تهیه
                  میکنید در این مدت 3 ماهه بدون هیچ محدودیتی از تمام امکانات
                  هاستد استفاده میکنید.
                </li>
              </ul>
              آیا تعداد داخلی ها و صف های تماس محدودیتی دارد؟
              <br />
              <ul>
                <li>
                  بلی، سرویس هاستد مکسفون درحال توسعه میباشد و درحال حاضر هر
                  کاربر میتواند 10 داخلی سه رقمی، 9 داخلی تک رقمی منوی صوتی و 9
                  صف تماس سه لایه تنظیم و تعیین کند.
                </li>
              </ul>
              نحوه پرداخت هزینه دایورت ها به چه شکلی هست؟
              <br />
              <ul>
                <li>
                  هزینه های دایورت ها بصورت پیش پرداخت با مبالغ دلخواه در اکانت
                  آسیاتک کاربر انجام میشود و سامانه مکسفون هیچ دخالتی در این
                  مورد ندارد. بعنوان مثال یک شارژ بیست هزارتومنی برای خط خود
                  خریداری میکنید.
                </li>
              </ul>
              منظور از تعداد کانال در بحث خط تلفن ابری چیست؟
              <br />
              <ul>
                <li>
                  یکی از ویژگی های تلفن ثابت ابری امکان برقراری چندین تماس ورودی
                  و خروجی به صورت همزمان است. به مجموع تعداد تماس های ورودی و
                  خروجی که می تواند به صورت همزمان صورت پذیرد تعداد کانال می
                  گویند. با ثبت نام تلفن ثابت ابری به صورت پیش فرض تعداد 3 کانال
                  خواهید داشت. برای راهنمایی و سفارش تعداد کانال بیشتر، لطفا
                  درخواست خود را از طریق تیکت ارسال نمایید.
                </li>
              </ul>
              اگر هنوز هم در رابطه با تلفن ابری سوالی دارید با ما تماس بگیرید
              <a href="tel:09053638893">09053638893</a> -
              <a href="tel:09198362447">09198362447</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudPhoneFrequentlyAskedQuestions;
